import React, { useEffect } from 'react';
import Navbar from './Components/Navbar'; // Adjust path as needed
import Footer from '../Components/Footer'; // Adjust path as needed
import Policy from './Components/Policy';

const ShippingPolicy = () => {
    useEffect(()=>{
        window.scrollTo(0,0)
    })
  const shippingContent = [
    "We aim to deliver your order as promptly as possible. Depending on the product selected, we offer same-day or next-day delivery (Glasgow & UK), unless mentioned otherwise.",
    "Customised orders, workshops, and gift boxes follow a timeline agreed upon by both the client and our team, which will be communicated via email or WhatsApp once the order is confirmed.",
    "For same-day delivery, orders must be placed before the cut-off time on the day of. Orders placed after the cut-off will be delivered the following day.",
    "For next-day delivery, orders must be placed before the stated cut-off for delivery on the next day.",
    "If you have an urgent requirement, please reach out to us on WhatsApp - we'll do our best to accommodate you.",
    "Deliveries are made via our chosen courier or in-person where applicable. To ensure a smooth experience, please double-check that your contact details and postcode are accurate.",
    "While we take great care in packing each order to preserve its quality, we are not responsible for any changes to the product caused by delays due to incorrect contact information or failure to accept the order on time."
  ];

  return (
    <div className="page-container">
      <Navbar />
      <Policy title="Shipping Policy" content={shippingContent} />
      <Footer />
    </div>
  );
};

export default ShippingPolicy;
